import Axios from 'axios'
const { REACT_APP_BRAND_API, REACT_APP_API_GET_PRODUCTS } = process.env

export function Api() {
  async function post(data) {
    try {
      await Axios.post(REACT_APP_BRAND_API, data)
    } catch (error) {
      console.error(error)
    }
  }

  async function get(query) {
    try {
      const response = await Axios.get(REACT_APP_API_GET_PRODUCTS + query)
      return response
    } catch (error) {
      console.error(error)
    }
  }

  return {
    post,
    get,
  }
}
